<template>
  <b-modal
    ref="modal"
    :title="$t('Reprocessar importação')"
    centered
    hide-footer
  >
    <div>
      <p class="mb-3">
        {{ $t("Tem certeza que deseja reprocessar esta importação?") }}
      </p>

      <div v-if="importacao" class="alert alert-info py-2">
        <strong>{{ $t("Arquivo") }}:</strong>
        {{ importacao.original_filename || "-" }}
      </div>

      <div class="d-flex justify-content-end mt-4">
        <button
          type="button"
          class="btn btn-secondary mr-2"
          @click="fecharModal"
        >
          {{ $t("Voltar") }}
        </button>

        <button
          type="button"
          class="btn btn-success"
          @click="confirmar"
        >
          <i class="fas fa-redo"></i>
          {{ $t("Confirmar reprocessamento") }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ReprocessarImportacaoModal",

  data() {
    return {
      importacao: null,
    };
  },

  methods: {
    abrirModal(importacao) {
      this.importacao = importacao;
      this.$refs.modal.show();
    },

    fecharModal() {
      this.$refs.modal.hide();
    },

    confirmar() {
      if (!this.importacao || !this.importacao.id) {
        return;
      }

      this.$emit("confirm", this.importacao);

      this.fecharModal();
    },
  },
};
</script>